<template>
  <div> 
    <v-navigation-drawer 
      v-model="show" 
      app=""  
      :expand-on-hover="false"
      color="b1 darken-" 
      left=""> 
      <v-divider></v-divider>  

      <v-list
        nav="" dense=""> 
        <v-list-item 
          :to="'/'" >
          <v-list-item-icon class=""><v-icon >dashboard</v-icon></v-list-item-icon> 
          <v-list-item-title >Dashboard</v-list-item-title>
        </v-list-item>
        <!-- dashboards -->
        <v-list-group  
            :no-action="true"
            prepend-icon="mdi-view-list"> 
            <v-list-item slot="activator"  >
              <v-list-item-content>Interventions</v-list-item-content> 
            </v-list-item> 
            <div  v-for=" (occurrence, i) in filteredOccurrences" 
              :key="i">
              <v-list-item v-if="filteredOccurrences"
                :to="'/intervention/'+occurrence.code" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-view-dashboard-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >{{occurrence.name}}</v-list-item-title>
              </v-list-item>
            </div>  
        </v-list-group>
         <!-- Checklist -->
        <v-list-group  
            v-if="accessPage('checklist')"
            :no-action="true"
            prepend-icon="mdi-playlist-edit"> 
            <v-list-item slot="activator"  >
              <v-list-item-title>Checklist</v-list-item-title>
            </v-list-item> 
            <div>
              <v-list-item 
                  to="/checklist/questions/configurations" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-playlist-edit</v-icon></v-list-item-icon> 
                <v-list-item-title >Question Configurations</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/checklist/questions'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-format-list-numbered</v-icon></v-list-item-icon> 
                <v-list-item-title >Questionnaire</v-list-item-title>
              </v-list-item>
              
            </div>
        </v-list-group>

         <!-- Reports -->
        <v-list-group 
            v-if="accessPage('reports')" 
            :no-action="true"
            prepend-icon="mdi-message-text"> 
            <v-list-item slot="activator"  >
              <v-list-item-title>Reports</v-list-item-title>
            </v-list-item> 
            <div>
              <!-- <v-list-item 
                  :to="'/reports/map'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-map</v-icon></v-list-item-icon> 
                <v-list-item-title >Map Reports</v-list-item-title>
              </v-list-item> -->
              <v-list-item 
                  :to="'/reports/report'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Create Report</v-list-item-title>
              </v-list-item>
              <v-list-item 
                  :to="'/reports/web'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-web</v-icon></v-list-item-icon> 
                <v-list-item-title >Web Reports</v-list-item-title>
              </v-list-item>
              <v-list-item 
                  :to="'/reports/whatsapp'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-whatsapp</v-icon></v-list-item-icon> 
                <v-list-item-title >WhatsApp Reports</v-list-item-title>
              </v-list-item>
              <v-list-item 
                  :to="'/reports/mobile'" >
                <v-list-item-icon class="pl-5"><v-icon >phone_android</v-icon></v-list-item-icon> 
                <v-list-item-title >Mobile App Reports</v-list-item-title>
              </v-list-item>
              <v-list-item 
                  :to="'/reports/sms'" >
                <v-list-item-icon class="pl-5"><v-icon >sms</v-icon></v-list-item-icon> 
                <v-list-item-title >SMS Reports</v-list-item-title>
              </v-list-item>
            </div>
        </v-list-group>

        
         <!-- Settings -->
        <v-list-group  
            v-if="accessPage('settings')"
            :no-action="true"
            prepend-icon="settings"> 
            <v-list-item slot="activator"  >
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item> 
            <div>
              <v-list-item 
                  :to="'/settings/users'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-account-multiple</v-icon></v-list-item-icon> 
                <v-list-item-title >Users</v-list-item-title>
              </v-list-item>
              <v-list-item 
                  :to="'/settings/user-groups'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-account-multiple</v-icon></v-list-item-icon> 
                <v-list-item-title >User Group </v-list-item-title>
              </v-list-item>
              <v-list-item 
                  :to="'/settings/permissions'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-account-multiple</v-icon></v-list-item-icon> 
                <v-list-item-title >Permissions </v-list-item-title>
              </v-list-item>
              
               
              <v-list-item 
                  :to="'/settings/reporters'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-account-supervisor</v-icon></v-list-item-icon> 
                <v-list-item-title >Reporters</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/interventions'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Interventions</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/countries'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Countries</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/regions'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Regions</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/districts'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Districts</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/constituencies'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Constituencies</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/wards'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Wards</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/centres'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Centres</v-list-item-title>
              </v-list-item> 
              <v-list-item 
                  :to="'/settings/tradition-authorities'" >
                <v-list-item-icon class="pl-5"><v-icon >mdi-square-edit-outline</v-icon></v-list-item-icon> 
                <v-list-item-title >Tradition Authorities</v-list-item-title>
              </v-list-item> 
            </div>
        </v-list-group>
      </v-list>
       
    </v-navigation-drawer>
  </div>
</template>

<script>
import DATA from '../../plugins/DATA'
import {mapState} from "vuex"
import items from '../../store/items';
let PAGE_NAME = DATA.ITEMS.OCCURRENCES.values 
export default {
  props:["not","navOpen"],
  data: () => ({
     show: true
  }),
  computed: {
    ...mapState({
        loading:state=>state.load.loading,
        processes:state=>state.load.processes,
        responses:state=>state.load.responses,
    }),
    ...mapState({
        us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
        ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
    }),
    ...mapState({
        Occurrences: state=> state.items[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()],
        JoinedOccurrences: state=> state.join[(DATA.ITEMS.OCCURRENCES.values).toUpperCase()]
    }),  
    OccurrencesData(){ 
        return this.JoinedOccurrences?this.JoinedOccurrences:this.Occurrences
    },
    filteredOccurrences(){ 
      let occurrences = this.OccurrencesData
      if(!occurrences){return null}
      let items = occurrences.filter(item=>!item.disabled)
        return items
    },
    
    us(){
      return this.not.us
    }, 
    questionStages(){
      let stages = this.$store.getters.getQuestionStages
      if(!stages){return null}
      let not_covid_staget = stages.filter(st=>{
          return this.not.TEXT_UP(st.name) != "COVID19"
      })
      return not_covid_staget
    },
    accessPage(){
      return page=>{
        return this.not.ACCESS_PAGE(page,false) 
      }
    }, 
  },
  watch: {
    navOpen(value){ 
      this.show = !this.show   
    },
  },
};
</script>
